/**
 * Journey deep links → routes in this app.
 *
 * Journey UX §6: "Every event opens the original experience." core-lambda's
 * `deep_link_for()` (journey_module/read_model.py) answers `{target, id}` for
 * ten targets, but this client only has a surface for some of them. A target
 * with no surface returns null and its row renders as plain text — a tappable
 * row that goes nowhere, or to a screen that cannot resolve the id, is worse
 * than a row that is plainly not tappable.
 *
 * Each mapping below was checked against a live `home-screen` payload rather
 * than assumed:
 *  - `voice_session` and `conversation` ids are chat *session* ids:
 *    `GET /ARIS/v2/chat/history?session_id=<deep_link.id>` returns the
 *    transcript, and `/chat?sessionId=` is the handoff Session History
 *    already uses to reopen one.
 *  - `dialogue` carries a dialogue **instance** ref, while
 *    `/explore/dialogue/:dialogueId` loads a dialogue **template**
 *    (`GET /ARIS/dialogues/{template_id}`). Different id spaces, so it is not
 *    routed — wiring it would produce a row that always fails to open.
 *  - `commitment` opens the commitment detail (/journey/commitments/:id).
 *  - `presence`, `saved_artifact`, `discovery` and `assessment` have no member
 *    surface in this app yet, and unknown targets stay not tappable so a newer
 *    server can add one without breaking the client.
 */
export const routeForDeepLink = (deepLink) => {
  const target = deepLink?.target;
  const id = deepLink?.id;
  switch (target) {
    case "conversation":
    case "voice_session":
      return id ? `/chat?sessionId=${encodeURIComponent(id)}` : null;
    // Both are single-valued per member, so the route needs no id.
    case "mission":
      return "/journey/mission";
    case "commitment":
      return id ? `/journey/commitments/${encodeURIComponent(id)}` : null;
    default:
      return null;
  }
};

export default routeForDeepLink;
